export default "__VITE_ASSET__Dv_o3NJj__"